// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2gw0N","select":"Header_select__3rZCj","clinic":"Header_clinic__wGVzQ"};